import React from "react";
import "../styles/Footer.css";

export default function Footer() {
    return (
        <div className="footer">
            <a href="https://github.com/M-Dickerson" target="blank"><i class="fa-brands fa-square-github"></i></a>
            <a href="https://www.linkedin.com/in/morgan-dickerson-512930260/" target='blank'><i class="fa-brands fa-linkedin"></i></a>
            <a href="https://stackoverflow.com/users/21083166/morgannn" target='blank'><i class="fa-brands fa-stack-overflow"></i></a>
        </div>
    );
}